import { LitElement, html } from "lit";
import { internalNavStyles } from "js/sharedStyles/internalNav.js";
class BCWJInternalNav extends LitElement {
  static styles = [internalNavStyles];

  static properties = {
    sourceid: {},
    title: {},
  };
  constructor() {
    super();
  }
  getLinks() {
    let element = document.getElementById(this.sourceid);
    if (element) {
      const headers = [...element.querySelectorAll("h2,h3,h4,h5")];

      let linkedHeaders = headers
        .filter((header) => {
          return header.id;
        })
        .map((header) => {
          return {
            id: header.id,
            text: header.innerText,
          };
        });

      return linkedHeaders;
    }
  }
  render() {
    const links = this.getLinks();
    const baseUrl = window.location.pathname;
    return links.length === 0
      ? html``
      : html`
          <div class="sticky-internal-nav c-internal-nav">
            <h5 class="mb--">${this.title}</h5>
            <ul>
              ${links.map((link) => {
                return html`<li>
                  <a class="c-link c-link--accent" href="${baseUrl}#${link.id}"
                    >${link.text}</a
                  >
                </li>`;
              })}
            </ul>
          </div>
        `;
  }
}

const initBCWJInternalNav = () => {
  window.customElements.define("bc-wj-internal-nav", BCWJInternalNav);
};
export { initBCWJInternalNav };
